import React from 'react';
import { isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { Typography, IconButton, Link, Button, Avatar } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { useTranslation } from 'react-i18next';

import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';
import BidPresenter from 'presenters/BidPresenter';
import Icon from 'sharedComponents/Icon';
import PhoneIcon from '@material-ui/icons/Phone';

import useStyles from './useStyles';

const LoanOfficerCard = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { isOnline, loanOfficer, bid, onClick, onBack } = props;

  const isBidPresent = isPresent(bid);
  const isApplicationUrlPresent = isPresent(LoanOfficerPresenter.applicationUrl(loanOfficer));
  const apr = isBidPresent ? BidPresenter.getApr(bid) : '--';
  const payment = isBidPresent ? BidPresenter.monthlyPrInMi(bid) : '--';
  const interestRate = isBidPresent ? BidPresenter.getInterestRate(bid) : '--';

  const isLoanOfficerPresent = isPresent(loanOfficer);
  const loanOfficerName = isLoanOfficerPresent
    ? LoanOfficerPresenter.fullName(loanOfficer)
    : t('models.App.userTypes.loanOfficer');
  const imageUrl = isLoanOfficerPresent ? LoanOfficerPresenter.profileImageUrl(loanOfficer) : '';
  const avatarLabel = isLoanOfficerPresent ? LoanOfficerPresenter.initials(loanOfficer) : '';

  return (
    <div className={classes.container}>
      <div className={classes.loanOfficerBadge}>
        <div className={classes.loanOfficerInfo}>
          <IconButton onClick={onBack} className={classes.backButton}>
            <Icon name="backArrow" />
          </IconButton>
          <Avatar src={imageUrl} label={avatarLabel} className={classes.avatar} />
          {isLoanOfficerPresent ? (
            <Typography variant="h2" noWrap className={classes.name}>
              {loanOfficerName}
            </Typography>
          ) : (
            <Skeleton width={100} height={30} />
          )}
          {isOnline && (
            <Typography variant="subtitle1" color="inherit" className={classes.onineStatus}>
              {t('components.LoanOfficerCard.online')}
            </Typography>
          )}
        </div>
        <IconButton onClick={onClick}>
          <Icon name="menu" />
        </IconButton>
      </div>
      {isBidPresent ? (
        <div className={classes.bidBadge}>
          <div className={classes.bottomBarLeft}>
            <Typography variant="subtitle1" color="secondary">
              {t('components.BuyerMessages.MobileMessages.ChatPage.LoanOfficerCard.interestRate')}
            </Typography>
            <Typography variant="h2" className={classes.bidInfoText}>
              {interestRate}
            </Typography>
          </div>
          <div className={classes.bottomBarCenter}>
            <Typography variant="subtitle1" color="secondary">
              {t('components.BuyerMessages.MobileMessages.ChatPage.LoanOfficerCard.apr')}
            </Typography>
            <Typography variant="h2" className={classes.bidInfoText}>
              {apr}
            </Typography>
          </div>
          <div className={classes.bottomBarRight}>
            <Typography variant="subtitle1" color="secondary">
              {t('components.BuyerMessages.MobileMessages.ChatPage.LoanOfficerCard.payment')}
            </Typography>
            <Typography variant="h2" className={classes.bidInfoText}>
              {payment}
            </Typography>
          </div>
        </div>
      ) : (
        <div className={classes.noBidBadge}>
          <div className={classes.noBidBadge2}>
            <div className={classes.bottomBarLeft}>
              <Typography variant="subtitle1" color="secondary">
                {t('components.BuyerMessages.MobileMessages.ChatPage.LoanOfficerCard.interestRate')}
              </Typography>
            </div>
            <div className={classes.bottomBarCenter}>
              <Typography variant="subtitle1" color="secondary">
                {t('components.BuyerMessages.MobileMessages.ChatPage.LoanOfficerCard.apr')}
              </Typography>
            </div>
            <div className={classes.bottomBarRight}>
              <Typography variant="subtitle1" color="secondary">
                {t('components.BuyerMessages.MobileMessages.ChatPage.LoanOfficerCard.payment')}
              </Typography>
            </div>
          </div>
          <Typography variant="h2" className={classes.bidInfoText}>
            Mortgage Quote Under Review
          </Typography>
        </div>
      )}
      <div className={classes.loLinksBox}>
        {isApplicationUrlPresent && (
          <Button
            className={classes.loButton}
            href={LoanOfficerPresenter.applicationUrl(loanOfficer)}
            component={Link}
            target="_blank"
            startIcon={<Icon name="done" className={classes.icon} />}
          >
            {t('components.BuyerMessages.MobileMessages.ChatPage.LoanOfficerCard.accept')}
          </Button>
        )}

        {!!LoanOfficerPresenter.phoneNumber(loanOfficer) && (
          <Button
            className={classes.loButton2}
            href={LoanOfficerPresenter.phoneLink(loanOfficer)}
            component={Link}
            startIcon={<PhoneIcon />}
          >
            {t('components.BuyerMessages.MobileMessages.ChatPage.LoanOfficerCard.callMe')}
          </Button>
        )}
      </div>
    </div>
  );
};

LoanOfficerCard.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape(),
  onBack: PropTypes.func.isRequired,
  isOnline: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  bid: BidPresenter.shape(),
};

LoanOfficerCard.defaultProps = {
  loanOfficer: {},
  bid: {},
};

export default LoanOfficerCard;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/ChatPage/components/LoanOfficerCard/LoanOfficerCard.js